export const effarigQuotes = {
  initial: {
    id: 0,
    lines: [
      "Добро пожаловать в мое скромное жилище.",
      "Я - Эффариг, и я управляю Глифами.",
      "Я отличаюсь от Терезы; не такой простой, как ты думаешь.",
      "Я использую осколки Глифов для изъявления собственной воли.",
      "Я собираю их для даров этого королевства.",
      "Чего ты ждешь? Приступай.",
    ]
  },
  unlockWeights: {
    id: 1,
    lines: [
      "Тебе нравится мой небольшой магазин? Он небольшой, но зато мой."
    ]
  },
  unlockGlyphFilter: {
    id: 2,
    lines: [
      "Эта покупка поможет тебе."
    ]
  },
  unlockSetSaves: {
    id: 3,
    lines: [
      "Это слишком много? Я думаю это слишком много."
    ]
  },
  unlockRun: {
    id: 4,
    lines: [
      "Ты выкупил весь мой товар... что ж, зато теперь я богат.",
      "Сердце моей Реальности - страдание. Каждый Слой сложнее предыдущего.",
      "Я надеюсь ты никогда не пройдешь её.",
    ]
  },
  completeInfinity: {
    id: 5,
    lines: [
      { text: "Вы прошли Бесконечность Эффарига.", showCelestialName: false },
      "Это - первый порог. Дальше будет только хуже.",
      "Никто кроме меня не знает достаточно об этой области, чтобы пройти дальше.",
    ]
  },
  completeEternity: {
    id: 6,
    lines: [
      { text: "Вы прошли Вечность Эффарига.", showCelestialName: false },
      "Это предел. Я не хочу чтобы ты продолжал.",
      "Ты не закончишь это никогда в жизни.",
      "Я просто подожду здесь пока ты сдашься.",
    ]
  },
  completeReality: {
    id: 7,
    lines: [
      { text: "Вы прошли Реальность Эффарига.", showCelestialName: false },
      "Так это и есть дьявольская сила... то, что пугало остальных...",
      "Ты думаешь это того стоило? Топтание того, что я сотворил?",
      "И с какой целью? Ты мог бы присоединиться, мы могли бы сотрудничать.",
      "Но нет. Всё кончено. Уходи, пока я цепляюсь за остатки.",
    ]
  }
};
